interface DayPilotRange {
  clientState: { [key: string]: any };
}

interface DayPilotDate {
  toDate: () => Date;
}

interface Switcher {
  commandCallBack: (command: string) => any;
  day: string | Date;
  l: {
    start: DayPilotDate;
    end: DayPilotDate;
  };
}

interface DayPilotNavigator {
  visibleRangeChangedCallBack: (e?: any) => any;
}

declare global {
  interface Window {
    dp_day: DayPilotRange;
    dp_week: DayPilotRange;
    dp_month: DayPilotRange;
    switcher: Switcher;
    dp_navigator: DayPilotNavigator;
  }
}

export const getSelectedTimeRange = (): [Date, Date] => {
  let startDate, endDate;
  const switcher = window.switcher;

  if (typeof switcher.day === "string") {
    startDate = new Date(switcher.day);
    endDate = new Date(startDate.valueOf());
    endDate.setDate(endDate.getDate() + 1);
  } else {
    startDate = switcher.l.start.toDate();
    endDate = switcher.l.end.toDate();
  }

  return [startDate, endDate];
};

export const setClientStateFilterJson = (filterJson: string) => {
  window.dp_day.clientState.filterJson = filterJson;
  window.dp_week.clientState.filterJson = filterJson;
  window.dp_month.clientState.filterJson = filterJson;
};

export const refreshDayPilot = () => {
  getActiveSwitcher()?.commandCallBack("refresh");
  window.setTimeout(window.dp_navigator.visibleRangeChangedCallBack(), 500);
};

export const getActiveSwitcher = (): Switcher | undefined => {
  const switcher = (window as any).switcher;
  const activeSwitcher = eval(switcher.active.id);
  return activeSwitcher;
};

export const getNavigator = (): DayPilotNavigator | undefined => {
  return window.dp_navigator;
};
